import { apiClient } from './client'
import type {
  PermissionRequest,
  PermissionRequestListResponse,
  CreatePermissionRequestPayload,
} from '@/types/permission'

export const permissionRequestsApi = {
  /**
   * Get all permission requests (with optional filters)
   */
  async list(params?: {
    status?: string
    requesterId?: string
    targetUserId?: string
    page?: number
    pageSize?: number
  }) {
    const response = await apiClient.get<{
      success: boolean
      data: PermissionRequestListResponse
    }>('/permission-requests', { params })
    return response.data
  },

  /**
   * Get pending permission requests only
   */
  async getPending() {
    const response = await apiClient.get<{
      success: boolean
      data: PermissionRequestListResponse
    }>('/permission-requests/pending')
    return response.data
  },

  /**
   * Get a specific permission request
   */
  async getById(id: string) {
    const response = await apiClient.get<{
      success: boolean
      data: PermissionRequest
    }>(`/permission-requests/${id}`)
    return response.data
  },

  /**
   * Create a new permission request
   */
  async create(payload: CreatePermissionRequestPayload) {
    const response = await apiClient.post<{
      success: boolean
      data: { request: PermissionRequest; autoApproved: boolean }
    }>('/permission-requests', payload)
    return response.data
  },

  /**
   * Approve a permission request
   */
  async approve(id: string, notes?: string) {
    const response = await apiClient.post<{
      success: boolean
      data: PermissionRequest
    }>(`/permission-requests/${id}/approve`, { notes })
    return response.data
  },

  /**
   * Reject a permission request
   */
  async reject(id: string, reason: string) {
    const response = await apiClient.post<{
      success: boolean
      data: PermissionRequest
    }>(`/permission-requests/${id}/reject`, { reason })
    return response.data
  },
}
